/**
 * Custom Cursor
 * Conflicting follower disabled — standard clean native cursor is active across all devices.
 */
export default function Cursor() {
  return null;
}
